/*
 * Copyright (c) 2020 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { ContainerModel, TextModel, ValueModel } from '@typescript-kit/view';

export class TimeClockShellComponentModel extends ContainerModel {

  get alertContainer(): ContainerModel {
    return this.items.get('alertContainer') as ContainerModel;
  }

  get title(): TextModel {
    return this.items.get('title') as TextModel;
  }

  get time(): ValueModel {
    return this.items.get('time') as ValueModel;
  }

  get date(): ValueModel {
    return this.items.get('date') as ValueModel;
  }

  get footer(): ContainerModel {
    return this.items.get('footer') as ContainerModel;
  }

}
